//@flow
import React, { Component } from 'react';
import type { Node } from 'react';
import injectSheet from 'react-jss';
import modalCss from '../styles/modal';
import closeBtn from '../images/close.svg';
import SVGInline from 'react-svg-inline';

type Props = {
    classes: Object,
    shown: boolean,
    feature: string,
    limit: number,
    handleModalState: Function
}
class DeleteAccountModal extends Component<Props, State> {
    componentWillReceiveProps (nextProps) {
        const { shown } = nextProps;
        this.setModalState(shown);
    }
    setModalState (shown) {
        if (this.props.shown === shown) {
            return;
        }
        this.props.handleModalState(shown);
    }
    componentWillMount() {
        const { shown } = this.props;
        this.setModalState(shown);
    }
    render() {
        const { shown } = this.props;
        if(!shown) {
            return null;
        }
        const { 
            classes,
            content
        } = this.props;
        let containerClass = classes.modalCont;
        
        return (
            <div className={classes.modal} id="account-delete-modal">
                <div className={`account-delete-container ${containerClass}`}>
                    <SVGInline svg={closeBtn} className="account-delete-close-btn" onClick={() => this.setModalState(false)} />
                    <div className={`account-delete-content ${classes.modalContent}`}>{content}</div>
                </div>
            </div>
        );
    }
}
export default injectSheet(modalCss)(DeleteAccountModal); 